.link {
  color: inherit;
  text-decoration: none;
}

.link:hover :global(.ant-avatar),
.link:active :global(.ant-avatar) {
  opacity: 80%;
}

.link:focus :global(.ant-avatar) {
  opacity: 100%;
}

.link-hover:hover {
  color: var(--rc-theme-color-primary-default);
  text-decoration: underline;
}

.link-focus:focus-visible {
  outline: 2px solid var(--rc-theme-color-primary-default);
  outline-offset: 1px;
}

.link-radius:focus-visible {
  border-radius: 2px;
}

.icon {
  margin-right: var(--rc-theme-spacing-xs);
}
